import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function CarlsbadPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="min-h-screen bg-white">
        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": "https://valvebuyers.com/carlsbad",
                "url": "https://valvebuyers.com/carlsbad",
                "name": "We Buy Valves Carlsbad NM | Surplus Industrial Equipment Buyer",
                "description": "Leading buyer of surplus valves and industrial equipment in Carlsbad, NM. Serving Delaware Basin oil & gas facilities, potash operations, and refinery equipment with fast response.",
                "breadcrumb": {
                  "@type": "BreadcrumbList",
                  "itemListElement": [
                    {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "Home",
                      "item": "https://valvebuyers.com"
                    },
                    {
                      "@type": "ListItem",
                      "position": 2,
                      "name": "New Mexico",
                      "item": "https://valvebuyers.com/new-mexico"
                    },
                    {
                      "@type": "ListItem",
                      "position": 3,
                      "name": "Carlsbad",
                      "item": "https://valvebuyers.com/carlsbad"
                    }
                  ]
                }
              },
              {
                "@type": "LocalBusiness",
                "@id": "https://valvebuyers.com/carlsbad#business",
                "name": "Valve Buyers - Carlsbad NM",
                "image": "https://valvebuyers.com/logo.png",
                "description": "Professional buyer of surplus valves and industrial equipment in Carlsbad, NM. Specializing in oil & gas production, refinery, and potash mining equipment from Delaware Basin facilities.",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Carlsbad",
                  "addressRegion": "NM",
                  "postalCode": "88220",
                  "addressCountry": "US"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": 32.4207,
                  "longitude": -104.2288
                },
                "url": "https://valvebuyers.com/carlsbad",
                "telephone": "+1-555-VALVES",
                "priceRange": "$$$",
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                    "opens": "08:00",
                    "closes": "17:00"
                  },
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": "Saturday",
                    "opens": "09:00",
                    "closes": "14:00"
                  }
                ],
                "areaServed": [
                  {
                    "@type": "City",
                    "name": "Carlsbad",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Artesia",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Loving",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Malaga",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Jal",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Eunice",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  }
                ],
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Surplus Industrial Equipment Buying Services",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Fisher Control Valve Acquisition",
                        "description": "Purchase of Fisher control valves including DVC6200, 657, 667, and Fieldvue digital positioners from oil & gas and refinery facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Gate & Globe Valve Purchasing",
                        "description": "Acquisition of gate valves, globe valves, and check valves from Delaware Basin production and processing facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Ball Valve & Specialty Valve Buying",
                        "description": "Purchase of ball valves, butterfly valves, plug valves, and specialty valves from oil & gas and potash operations"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Instrumentation Equipment Acquisition",
                        "description": "Buying pressure transmitters, flow meters, temperature sensors, and control panels from production and processing facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Refinery Equipment Purchasing",
                        "description": "Acquisition of refinery valves, heat exchangers, pumps, and process equipment from Carlsbad area facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Emergency Equipment Buyout",
                        "description": "Rapid response purchasing for facility closures, upgrades, and turnaround projects in Carlsbad area"
                      }
                    }
                  ]
                }
              },
              {
                "@type": "Service",
                "@id": "https://valvebuyers.com/carlsbad#service",
                "serviceType": "Industrial Equipment Acquisition",
                "provider": {
                  "@id": "https://valvebuyers.com/carlsbad#business"
                },
                "areaServed": [
                  {
                    "@type": "City",
                    "name": "Carlsbad",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Artesia",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Loving",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Malaga",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Jal",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Eunice",
                    "containedIn": "New Mexico"
                  }
                ],
                "description": "Professional acquisition of surplus valves and industrial equipment from oil & gas production facilities, refineries, potash operations, and processing plants throughout the Delaware Basin region."
              },
              {
                "@type": "FAQPage",
                "@id": "https://valvebuyers.com/carlsbad#faq",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "What types of valves do you buy in Carlsbad, NM?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We purchase all types of industrial valves in Carlsbad including Fisher control valves (DVC6200, 657, 667, Fieldvue), gate valves, globe valves, ball valves, check valves, butterfly valves, plug valves, and specialty valves. We specialize in equipment from oil & gas production facilities, refineries, potash operations, and processing plants throughout the Delaware Basin."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How quickly can you respond to Carlsbad facilities?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We provide 3-5 hour response time for Carlsbad and surrounding Delaware Basin facilities. Our team is familiar with local oil & gas operations, refinery equipment, and potash mining facilities, enabling rapid equipment assessment and competitive offers for your surplus equipment."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Do you buy equipment from potash operations in Carlsbad?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, we purchase surplus equipment from Carlsbad's potash mining operations including Intrepid Potash, Mosaic, and other facilities. We buy valves, pumps, instrumentation, and all related industrial equipment from potash processing plants and mining operations."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "What brands of control valves do you purchase in Carlsbad?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We purchase all major control valve brands in Carlsbad including Fisher (Emerson), Masoneilan, Crosby, Anderson Greenwood, Cashco, Mokveld, and Flowserve. We specialize in Fisher DVC6200, 657, 667 series, and Fieldvue digital positioners commonly used in Delaware Basin oil & gas and refinery facilities."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Do you buy instrumentation equipment from Carlsbad facilities?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, we purchase all types of instrumentation equipment from Carlsbad facilities including Rosemount pressure transmitters, flow meters, temperature sensors, level transmitters, control panels, PLCs, and analytical equipment. We buy from oil & gas production facilities, refineries, potash operations, and processing plants throughout the Delaware Basin."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "What is the process for selling valves in Carlsbad, NM?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Selling valves in Carlsbad is simple: 1) Contact us with your equipment list and photos, 2) We provide a competitive quote within 24 hours, 3) Upon acceptance, we arrange pickup from your Carlsbad facility within 3-5 hours, 4) Payment is processed immediately upon equipment verification. We handle all logistics and documentation for your convenience."
                    }
                  }
                ]
              }
            ]
          })}
        </script>

        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                We Buy Valves Carlsbad
              </h1>
              <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
                Leading buyer of surplus valves and industrial equipment in Carlsbad, NM. Serving Delaware Basin oil & gas facilities, potash operations, and refinery equipment with fast response and competitive pricing.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Get Quote Today
                </Link>
                <Link
                  to="/what-we-buy"
                  className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap border border-white/20"
                >
                  <i className="ri-list-check text-xl"></i>
                  Equipment We Buy
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-slate-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">3-5 hrs</div>
                <div className="text-slate-600 font-medium">Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">800+</div>
                <div className="text-slate-600 font-medium">Production Wells</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">3</div>
                <div className="text-slate-600 font-medium">Potash Operations</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">24/7</div>
                <div className="text-slate-600 font-medium">Emergency Service</div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-16 items-start">
              <div>
                <h2 className="text-4xl font-bold text-slate-900 mb-6">
                  Carlsbad Oil & Gas Equipment Buyer
                </h2>
                <div className="prose prose-lg max-w-none text-slate-600 space-y-4">
                  <p>
                    As the leading buyer of surplus valves and industrial equipment in Carlsbad, New Mexico, we specialize in purchasing equipment from Delaware Basin oil & gas facilities, potash operations, and refinery equipment. Our team provides rapid response and competitive pricing for all types of industrial equipment.
                  </p>
                  <p>
                    Carlsbad is strategically located in the heart of the Delaware Basin, one of the most productive oil & gas regions in the United States. The area is also home to significant potash mining operations. We serve major facilities including oil & gas production sites, potash processing plants, and refinery operations throughout southeastern New Mexico.
                  </p>
                  <p>
                    Our expertise in oil & gas production equipment, potash processing systems, and refinery operations ensures you receive maximum value for your surplus equipment. We understand the unique requirements of Delaware Basin operations and provide tailored solutions for facility upgrades, turnarounds, and closures.
                  </p>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-6">
                  <i className="ri-building-line text-teal-600 mr-3"></i>
                  Carlsbad Facilities We Serve
                </h3>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Delaware Basin Production</div>
                    <div className="text-slate-600 text-sm">800+ Oil & Gas Production Wells</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Intrepid Potash</div>
                    <div className="text-slate-600 text-sm">Potash Mining & Processing Operations</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Mosaic Potash Operations</div>
                    <div className="text-slate-600 text-sm">Underground Mining & Processing</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Gas Processing Facilities</div>
                    <div className="text-slate-600 text-sm">Multiple Processing Plants</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Pipeline Infrastructure</div>
                    <div className="text-slate-600 text-sm">Regional Pipeline Systems</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Compression Stations</div>
                    <div className="text-slate-600 text-sm">Gas Compression Operations</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Equipment Categories */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-slate-900 mb-4">
                Sell Valves Carlsbad NM
              </h2>
              <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                We purchase all types of industrial equipment from Carlsbad oil & gas facilities, potash operations, and refinery equipment
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-settings-3-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Fisher Control Valves</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fisher DVC6200:</strong> Digital valve controllers with HART protocol</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fisher 657/667:</strong> Size 30-70 diaphragm actuators</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fieldvue Digital:</strong> DVC6200, DVC6000 series positioners</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fisher ED/EZ Series:</strong> Easy-e and sliding stem valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Masoneilan Valves:</strong> 35-series and Camflex II control valves</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-door-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Gate & Globe Valves</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Gate Valves:</strong> 2"-24" Class 150-2500 carbon & stainless steel</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Globe Valves:</strong> Angle, Y-pattern, and conventional globe valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Check Valves:</strong> Swing, lift, and dual-plate check valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>API 6D Valves:</strong> Pipeline specification gate and ball valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>High Pressure:</strong> Class 600-2500 valves for production service</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-circle-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Ball & Specialty Valves</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Ball Valves:</strong> Floating, trunnion, and metal-seated ball valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Butterfly Valves:</strong> High-performance and triple-offset designs</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Plug Valves:</strong> Lubricated and non-lubricated plug valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Safety Relief:</strong> Crosby, Anderson Greenwood, and Consolidated valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Actuated Valves:</strong> Pneumatic, electric, and hydraulic actuators</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-dashboard-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Instrumentation</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Pressure Transmitters:</strong> Rosemount 3051, 2088, and 1151 series</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Flow Meters:</strong> Orifice, turbine, Coriolis, and ultrasonic meters</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Temperature Sensors:</strong> RTDs, thermocouples, and transmitters</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Control Panels:</strong> DCS systems, PLCs, and HMI equipment</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Analytical Equipment:</strong> Gas chromatographs and analyzers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Related Markets */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">
              Related Delaware Basin Markets
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <Link
                to="/artesia"
                className="group bg-slate-50 hover:bg-teal-50 rounded-xl p-8 transition-all border border-slate-200 hover:border-teal-200"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900">Artesia, NM</h3>
                </div>
                <p className="text-slate-600">Navajo Refinery and oil & gas production facilities</p>
              </Link>

              <Link
                to="/hobbs"
                className="group bg-slate-50 hover:bg-teal-50 rounded-xl p-8 transition-all border border-slate-200 hover:border-teal-200"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900">Hobbs, NM</h3>
                </div>
                <p className="text-slate-600">Permian Basin oil & gas production and processing</p>
              </Link>

              <Link
                to="/roswell"
                className="group bg-slate-50 hover:bg-teal-50 rounded-xl p-8 transition-all border border-slate-200 hover:border-teal-200"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900">Roswell, NM</h3>
                </div>
                <p className="text-slate-600">Holly Refinery and regional oil & gas operations</p>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Carlsbad Equipment Buyer
            </h2>
            <p className="text-xl text-teal-50 mb-8 leading-relaxed">
              Get competitive pricing for your surplus valves and industrial equipment. We provide 3-5 hour response time for Carlsbad and Delaware Basin facilities with immediate payment upon equipment verification.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-white text-teal-600 hover:bg-slate-50 px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Request Quote
              </Link>
              <Link
                to="/how-it-works"
                className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap"
              >
                <i className="ri-information-line text-xl"></i>
                How It Works
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">
              Carlsbad Valve Buyers FAQ
            </h2>
            <div className="space-y-6">
              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  What types of valves do you buy in Carlsbad, NM?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  We purchase all types of industrial valves in Carlsbad including Fisher control valves (DVC6200, 657, 667, Fieldvue), gate valves, globe valves, ball valves, check valves, butterfly valves, plug valves, and specialty valves. We specialize in equipment from oil & gas production facilities, refineries, potash operations, and processing plants throughout the Delaware Basin.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  How quickly can you respond to Carlsbad facilities?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  We provide 3-5 hour response time for Carlsbad and surrounding Delaware Basin facilities. Our team is familiar with local oil & gas operations, refinery equipment, and potash mining facilities, enabling rapid equipment assessment and competitive offers for your surplus equipment.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  Do you buy equipment from potash operations in Carlsbad?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  Yes, we purchase surplus equipment from Carlsbad's potash mining operations including Intrepid Potash, Mosaic, and other facilities. We buy valves, pumps, instrumentation, and all related industrial equipment from potash processing plants and mining operations.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  What brands of control valves do you purchase in Carlsbad?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  We purchase all major control valve brands in Carlsbad including Fisher (Emerson), Masoneilan, Crosby, Anderson Greenwood, Cashco, Mokveld, and Flowserve. We specialize in Fisher DVC6200, 657, 667 series, and Fieldvue digital positioners commonly used in Delaware Basin oil & gas and refinery facilities.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  Do you buy instrumentation equipment from Carlsbad facilities?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  Yes, we purchase all types of instrumentation equipment from Carlsbad facilities including Rosemount pressure transmitters, flow meters, temperature sensors, level transmitters, control panels, PLCs, and analytical equipment. We buy from oil & gas production facilities, refineries, potash operations, and processing plants throughout the Delaware Basin.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  What is the process for selling valves in Carlsbad, NM?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  Selling valves in Carlsbad is simple: 1) Contact us with your equipment list and photos, 2) We provide a competitive quote within 24 hours, 3) Upon acceptance, we arrange pickup from your Carlsbad facility within 3-5 hours, 4) Payment is processed immediately upon equipment verification. We handle all logistics and documentation for your convenience.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
